<template>
  <div
    :class="
      showOnMobile ? 'd-block text-center d-xl-none d-lg-none' : 'd-none d-xl-block d-lg-block'
    "
  >
    <b-button class="legend-button" variant="ghost" role="button" @click="() => toggle()">
      <span v-html="svgSeatLegend(16)"> </span>
      <span>
        {{ toggled ? 'Chiudi' : 'Legenda' }}
      </span>
    </b-button>
  </div>
</template>

<script>
import { svgSeatLegend } from '@/components/svg/seat-map';

export default {
  name: 'seat-map-info-button',
  props: {
    showOnMobile: Boolean,
    toggled: Boolean,
    toggle: Function,
  },
  data() {
    return {
      svgSeatLegend,
    };
  },
};
</script>

<style lang="scss">
.legend-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
  border: 1px silver solid;
  gap: 10px;
}
</style>
